import React from "react";
import ReactDOM from "react-dom";
import "./styles.css";

const CuadroTexto = ({
  message,
  onAccept,
  onCancel,
  showCancel = true,
  acceptText = "Aceptar",
  cancelText = "Cancelar",
  acceptClassName = "btn accept-btn",
  cancelClassName = "btn cancel-btn",
}) => {
  if (!message) return null;

  const modalContent = (
    <div className="message-overlay">
      <div className="message-box">
        <p className="message-text">{message}</p>
        <div className="message-buttons">
          {showCancel && (
            <button className={cancelClassName} onClick={onCancel}>
              {cancelText}
            </button>
          )}
          <button className={acceptClassName} onClick={onAccept}>
            {acceptText}
          </button>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default CuadroTexto;
